import React from 'react';
import { AuthContext } from './AuthContext';

export interface AuthSession {
  isAuthenticated: boolean;
  userId: string | null;
  email: string | null;
  groups: string[];
  signOut: () => Promise<void>;
}

export function useAuthSession(): AuthSession {
  const ctx = React.useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuthSession must be used inside FsAuthenticator');
  }
  return ctx.session;
}
